/**
 * @author Kevin <knielsen@alertlogic.com>
 *
 * @copyright Alert Logic, Inc 2022
 */
import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AlHtmlToJsonParser } from '../../types/al-html-to-json.parser';


@Component({
    selector: 'al-markdown-content',
    templateUrl: './al-markdown-content.component.html',
    styleUrls: ['./al-markdown-content.component.scss']
})
export class AlMarkdownContentComponent {

    public content?:string;

    constructor() {
    }
}
